<app-header
  *ngIf="modeConfig.displayHeader || mode === usfProductCardModeEnum.exceptionSearch"
  [hideBackButton]="(mode === usfProductCardModeEnum.defaultSearch && originSearchPage !== searchPagesEnum.catalog)"
></app-header>

<ion-content
  [scrollY]="searchViewModel?.listProducts?.length > 0 ? 'false' : 'true'"
>
  <div class="scrollable-content" cdkVirtualScrollingElement>
    <section class="search-layout">
      <section *ngIf="isTopSection && isTouchExperience">
        <ng-container *ngTemplateOutlet="topSection"></ng-container>
      </section>
      <section
        *ngIf="isTopSectionSingleBanner && isTouchExperience && !isGuestUser"
      >
        <ng-container *ngTemplateOutlet="topSectionSingleBanner"></ng-container>
      </section>
      <!-- Touch Banner -->
      <app-search-banner
        *ngIf="searchViewModel?.searchResponse?.richTextMainList?.length  &&
            isTouchExperience && !isLoading
            && modeConfig.displayBanners"
        [leftTitleConfig]="leftTitleOptions"
        [bannerType]="bannerType.ParentFloatingBanner"
        [searchResponse]="searchViewModel?.searchResponse"
        [termSearched]="searchViewModel?.searchResponse?.headerDetails?.headerText"
        (updateSearchText)="bannerSearchMode($event)"
      >
      </app-search-banner>
      <ng-container *ngTemplateOutlet="SectionToGoBack"></ng-container>
      <section
        class="mobile-search-filtering"
        *ngIf="!isLoading && isTouchExperience && platformService?.platformType === platformService?.platformEnum?.mobile"
      >
        <ng-container *ngTemplateOutlet="SearchResults"></ng-container>
        <ng-container
          *ngTemplateOutlet="SearchOperationsMobile;context:{$implicit:{orientation:'column',sortConfig:selectedSortOption,
      searchViewModel:searchViewModel}}"
        ></ng-container>
      </section>

      <section
        class="tablet-search-result"
        *ngIf="!isLoading && isTouchExperience && platformService?.platformType === platformService?.platformEnum?.tablet"
      >
        <ng-container *ngTemplateOutlet="SearchResults"></ng-container>
      </section>

      <app-search-breadcrumb
        *ngIf="modeConfig.displayBreadcrumbs"
        [breadcrumbData]="searchViewModel?.searchResponse?.breadCrumbs"
        [pageType]="searchViewModel?.searchResponse?.pageType"
      ></app-search-breadcrumb>
      <section
        *ngIf="!isTopSection"
        [ngClass]="isTouchExperience === true ? 'tablet-hide' : 'desktop-show'"
        class="title-section"
        data-cy="search-page-shop-products-label-text"
      >
        <h1>{{ 'i18n.search.shopProducts' | translate }}</h1>
      </section>

      <!-- Desktop Banner -->
      <section *ngIf="isTopSection && !isTouchExperience">
        <ng-container *ngTemplateOutlet="topSection"></ng-container>
      </section>
      <section
        *ngIf="isTopSectionSingleBanner && !isTouchExperience && !isGuestUser"
      >
        <ng-container *ngTemplateOutlet="topSectionSingleBanner"></ng-container>
      </section>

      <section class="desktop-banner">
        <app-search-banner
          *ngIf="searchViewModel?.searchResponse?.richTextMainList?.length &&
          !isTouchExperience  && modeConfig.displayBanners && !isLoading "
          [leftTitleConfig]="leftTitleOptions"
          [bannerType]="bannerType.ParentFloatingBanner"
          [searchResponse]="searchViewModel?.searchResponse"
          [termSearched]="searchViewModel?.searchResponse?.headerDetails?.headerText"
          (updateSearchText)="bannerSearchMode($event)"
        >
        </app-search-banner>
      </section>

      <app-search-skeleton
        *ngIf="isLoading"
        [isGuestUser]="isGuestUser"
      ></app-search-skeleton>
      <section
        class="search-content-results"
        [hidden]="!!searchViewModel?.error || !!isLoading"
        [ngClass]="isTouchExperience === false ? 'small-desktop-spacing' : 'tablet'"
      >
        <div
          class="filtering-section"
          *ngIf="!searchViewModel?.error && !isLoading"
        >
          <div
            class="desktop-search-filtering"
            *ngIf="!isLoading && !searchViewModel?.error && !isTouchExperience"
          >
            <ng-container
              *ngTemplateOutlet="SearchWithin;context:{$implicit:{searchViewModel:searchViewModel}}"
            >
            </ng-container>
            <app-search-filtering
              [navigation]="searchViewModel?.searchResponse?.navigation"
              [totalRecords]="searchViewModel?.searchResponse?.totalNumberOfRecords"
              [searchRequest]="searchViewModel?.searchRequest"
              [selectedFacets]="searchViewModel?.searchResponse?.selectedFacets"
              (selectFilterOption)="refreshSearchResult($event)"
              [searchResponse]="searchViewModel?.searchResponse"
            ></app-search-filtering>
          </div>
          <div
            class="tablet-search-filtering"
            *ngIf="!isLoading && isTouchExperience && platformService?.platformType === platformService?.platformEnum?.tablet"
          >
            <ng-container
              *ngTemplateOutlet="SearchWithin;context:{$implicit:{searchViewModel:searchViewModel}}"
            >
            </ng-container>
            <section class="operations">
              <ng-container
                *ngTemplateOutlet="SearchOperations;context:{$implicit:{orientation:'column',sortConfig:selectedSortOption,
          searchViewModel:searchViewModel}}"
              ></ng-container>
            </section>
          </div>
        </div>
        <section class="search-result-section" id="searchResult">
          <section
            class="desktop-title-search-result"
            *ngIf="!searchViewModel?.error && !isLoading && !isTouchExperience"
          >
            <ng-container *ngTemplateOutlet="SearchResults"></ng-container>
          </section>
          <ng-container *ngIf="!isTouchExperience">
            <ng-container
              *ngTemplateOutlet="SearchOperations;context:{$implicit:{sortConfig:selectedSortOption,
          searchViewModel:searchViewModel}}"
            ></ng-container>
          </ng-container>
          <section
            *ngIf="modeConfig.displayReplacementSection && !isLoading"
            class="mobile-replacement-section"
          >
            <ng-container
              *ngTemplateOutlet="OriginalItem;context:{$implicit:{replacementBaseProduct: replacementBaseProduct}}"
            >
            </ng-container>
          </section>
          <section
            *ngIf="modeConfig.displayReplacementSection"
            class="desktop-tablet-replacement-section"
          >
            <ng-container
              *ngTemplateOutlet="OriginalItem;context:{$implicit:{replacementBaseProduct: replacementBaseProduct}}"
            >
            </ng-container>
          </section>

          <app-search-result
            [pwrRatingStarsMap]="pwrRatingStarsMap | async"
            [searchViewModel]="searchViewModel"
            [mode]="mode"
            [modeConfig]="modeConfig"
            [replacementBaseProduct]="replacementBaseProduct"
            (selectionChange)="handleSelectedProducts($event)"
            [isTouchExperience]="isTouchExperience"
            [overrideExclusiveSelection]="productSelectionMode === compareProductsSelection"
            [itemsSelectable]="modeConfig.selectableItem || !!productSelectionMode"
            [itemHeights]="itemHeights"
            (scrolledIndexChange)="nextBatch($event)"
            [headerText]="headerText"
            [isGuestUser]="isGuestUser"
            [coveoTopSellers]="(coveoTopSellers$ | async)"
          ></app-search-result>
          <div
            *ngIf="searchViewModel?.isLoadingMore"
            class="search-result-skeleton-wrapper"
          >
            <ion-skeleton-text
              [animated]="true"
              [ngClass]="{'item-guest': isGuestUser , 'item ' : !isGuestUser}"
            ></ion-skeleton-text>
            <ion-skeleton-text
              [animated]="true"
              [ngClass]="{'item-guest': isGuestUser , 'item ' : !isGuestUser}"
            ></ion-skeleton-text>
            <ion-skeleton-text
              [animated]="true"
              [ngClass]="{'item-guest': isGuestUser , 'item ' : !isGuestUser}"
            ></ion-skeleton-text>
            <ion-skeleton-text
              [animated]="true"
              [ngClass]="{'item-guest': isGuestUser , 'item ' : !isGuestUser}"
            ></ion-skeleton-text>
          </div>
        </section>
      </section>
      <ng-container *ngIf="!isLoading">
        <section
          class="search-service-error-section"
          *ngIf="searchViewModel?.error"
        >
          <app-message-bar
            [isMobile]="false"
            [shouldDisplay]="true"
            [radius]="8"
            [textAlign]="'left'"
            [paddingX]="20"
            [paddingY]="14"
          >
            <div class="text-message" data-cy="error-message-text">
              <ion-icon
                name="alert-circle-outline"
                data-cy="error-message-text-icon"
              >
              </ion-icon>
              <p data-cy="error-message-primary-text" class="primary-text">
                {{ isTouchExperience ? ('i18n.search.messageBarTouch' |
                translate) : ('i18n.search.messageBarNotTouch' | translate) }}
              </p>
            </div>
          </app-message-bar>
        </section>
      </ng-container>
    </section>
    <section
      *ngIf="modeConfig.displayExceptionFooter"
      class="exception-footer"
    ></section>
    <app-footer *ngIf="modeConfig.displayFooter"></app-footer>
  </div>
  <section
    class="sticky-operations"
    *ngIf="!isLoading && searchViewModel?.searchResponse?.totalNumberOfRecords"
  >
    <div
      class="sticky-button-group"
      [class.has-selection]="modeConfig.displayFooterOptions && selectedProducts?.length>0"
    >
      <ng-container *appShowSplit="[compareButtonFeatureFlag]">
        <ion-button
          *ngIf="mode !== UsfProductCardModeEnum.addToInventorySearch"
          [ngClass]="(modeConfig.enableCompareButton || productSelectionMode === compareProductsSelection)
        ? 'usf-fill-green-button'
        : 'usf-outline-green-button'"
          data-cy="compare-button"
          (click)="handleCompareProducts()"
        >
          {{ 'i18n.search.searchResultOperationButtons.compare' | translate }}
        </ion-button>
      </ng-container>

      <ion-button
        *ngIf="modeConfig.displayAddToListButton && !isGuestUser"
        data-cy="add-to-list-button"
        [class]="(modeConfig.displayAddToListOption || productSelectionMode === addToListSelection) ? 'usf-fill-green-button':'usf-outline-green-button'"
        (click)="handleAddToListClick()"
      >
        + {{ 'i18n.lists.addToList' | translate }}
      </ion-button>

      <ion-button
        *ngIf="modeConfig.displayAddToInventory"
        data-cy="add-to-inventory-button"
        [class]="productSelectionMode === addToInventorySelection
        ? 'usf-fill-green-button'
        : 'usf-outline-green-button'"
        (click)="handleAddToInventoryClick()"
      >
        {{ 'i18n.search.searchResultOperationButtons.addToInventory' | translate
        }}
      </ion-button>

      <div class="go-top-icon" data-cy="top-button" (click)="goToTop()">
        <img
          data-cy="go-to-top-button"
          class="top-button-icon"
          src="assets/images/circle-chevron-up-green.png"
        />
      </div>
    </div>
  </section>
  <section
    class="sticky-action-bar"
    *ngIf="selectedProducts?.length > 0 &&
  (mode === UsfProductCardModeEnum.cartReplacementSearch || mode === UsfProductCardModeEnum.addToListSearch ||
    mode === UsfProductCardModeEnum.exceptionSearch || mode === UsfProductCardModeEnum.replacementSearch || mode === UsfProductCardModeEnum.addToInventorySearch || productSelectionMode === addToListSelection)"
  >
    <span
      class="selection-count"
      data-cy="add-to-list-product-selected-counts-text"
    >
      {{selectedProducts?.length}} {{selectedProducts?.length > 1 ? ' Products '
      : ' Product '}} Selected
    </span>

    <a *ngIf="selectedProducts.length >= 2" (click)="clearSelectedProducts()"
      >{{'i18n.search.addToListClearAll' | translate}}
    </a>

    <ion-button
      class="usf-outline-green-button add-to-list-button"
      data-cy="add-to-list-selected-product-open-modal-button"
      (click)="openActionModal()"
    >
      {{ footerText | translate }}
      <ion-icon
        name="chevron-forward-outline"
        data-cy="add-to-list-selected-product-open-modal-button-icon"
      >
      </ion-icon>
    </ion-button>
  </section>
  <section
    class="sticky-action-bar-compare"
    *ngIf="selectedProducts?.length > 0 &&
  (mode === UsfProductCardModeEnum.compareProducts || productSelectionMode === compareProductsSelection)"
  >
    <span
      class="selection-count"
      data-cy="compare-product-selected-counts-text"
    >
      {{ 'Compare ' + selectedProducts?.length + ' of 4'}}
    </span>

    <a *ngIf="selectedProducts.length >= 2" (click)="clearSelectedProducts()"
      >{{'i18n.search.compareClearAll' | translate}}
    </a>

    <ion-button
      [ngClass]="selectedProducts?.length <2
        ? 'usf-outline-green-button compare-button-disable'
        : 'usf-outline-green-button compare-button-enable'"
      data-cy="selected-compare-product-button"
      (click)="redirectToComparePage()"
      [disabled]="selectedProducts?.length <2"
    >
      {{ footerText | translate }}
      <ion-icon
        name="chevron-forward-outline"
        data-cy="compare-product-button-icon"
      >
      </ion-icon>
    </ion-button>
  </section>

  <section
    class="sticky-action-bar"
    *ngIf="selectedProducts?.length > 0 &&
    (mode === UsfProductCardModeEnum.addToInventorySearch)"
  >
    <span
      class="selection-count"
      data-cy="add-to-inventory-product-selected-counts-text"
    >
      {{selectedProducts?.length}} {{selectedProducts?.length > 1 ? ' Products '
      : ' Product '}} Selected

      <img
        class="add-to-inventory-separator"
        data-cy="add-to-inventory-separator-image"
        src="assets/images/separator.png"
      />

      <a
        *ngIf="selectedProducts.length >= 1"
        class="add-to-inventory-deselectAll"
        (click)="clearSelectedProducts()"
      >
        {{'i18n.search.addToInventoryDeselectAll' | translate}}
      </a>
    </span>

    <ion-button
      class="usf-outline-green-button add-to-inventory-button force-block"
      data-cy="add-to-Inventory-selected-product-open-modal-button"
      (click)="openActionModal()"
    >
      {{ footerText | translate }}
      <ion-icon
        name="chevron-forward-outline"
        data-cy="add-to-inventory-selected-product-open-modal-button-icon"
      >
      </ion-icon>
    </ion-button>
  </section>

  <ion-modal
    [isOpen]="this.addToListModalService.isModalOpen$ | async"
    (ionModalDidDismiss)="closeAndDeatachAddToListModal()"
    [class]="
    (platformService?.isTouchExperience$ | async)
      ? 'ion-modal-touch'
      : 'modal-desktop-size-xl'
  "
    [initialBreakpoint]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? 1
      : undefined
  "
    [breakpoints]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? [0, 1]
      : undefined
  "
    id="addToListModal"
  >
    <ng-template>
      <app-modal-with-nav-inline
        [rootPage]="this.addToListModalService.dualPaneRef"
        [rootPageParams]="this.addToListModalService.dualPaneModalData"
      >
      </app-modal-with-nav-inline>
    </ng-template>
  </ion-modal>
</ion-content>

<ng-template #SearchResults>
  <section class="search-text-result">
    <ng-container *ngIf="newScoopProducts !== headerText && !isTopSection">
      <h2
        class="text-searched"
        data-cy="searched-results-label-text"
        *ngIf="platformService.platformType !== platformService.platformEnum.mobile"
      >
        “{{ headerText | acronymTitleCase }}”
      </h2>
      <h2
        class="text-searched"
        data-cy="searched-results-label-text"
        *ngIf="platformService.platformType === platformService.platformEnum.mobile"
      >
        “{{ headerText | acronymTitleCase | truncateWithEllipsis: 18 }}”
      </h2>
    </ng-container>
    <span data-cy="searched-results-number-counts-text">
      ({{ searchViewModel?.searchResponse?.totalNumberOfRecords > 999 ? '999+' :
      searchViewModel?.searchResponse?.totalNumberOfRecords }} Results)
    </span>
    <div
      class="toggle-filter-search-tablet"
      *ngIf="showDeliveryToggle && platformService?.platformType === platformService?.platformEnum?.tablet"
    >
      <app-search-toggle-filter> </app-search-toggle-filter>
    </div>
    <ng-container *appShowSplit="[showDownloadButton]">
      <ng-container
        *ngIf="searchViewModel?.searchResponse?.totalNumberOfRecords > 0"
      >
        <app-share-print-download
          *ngIf="!isDownloading; else loadingSpinner"
          class="download-button"
          [showPrint]="false"
          (downloadButtonClick)="downloadSearchResults()"
          (ellipsisButtonClick)="openMobileActionSheet()"
          [isMobile]="platformService.platformType === platformService.platformEnum.mobile"
        ></app-share-print-download>
        <ng-template #loadingSpinner>
          <div class="downloading-spinner" data-cy="loading-spinner-container">
            <span data-cy="loading-spinner-message">
              {{ 'i18n.common.downloadingFile' | translate }}...
            </span>
            <ion-spinner
              name="circles"
              data-cy="loading-spinner-icon"
            ></ion-spinner>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>
  </section>
</ng-template>
<ng-template #SearchOperations let-default>
  <section class="operations">
    <app-search-operations
      *ngIf="!searchViewModel?.error && !isLoading"
      [orientation]="default?.orientation"
      [sortConfiguration]="default.sortConfig"
      [searchViewModel]="default?.searchViewModel"
      [showCompare]="mode !== UsfProductCardModeEnum.addToInventorySearch"
      [showAddToList]="mode !== UsfProductCardModeEnum.addToInventorySearch && modeConfig.displayAddToListButton"
      [showInventory]="mode === UsfProductCardModeEnum.addToInventorySearch && modeConfig.displayAddToInventory"
      [showDeliveryToggle]="showDeliveryToggle"
      [compareButtonSelected]="modeConfig.enableCompareButton || productSelectionMode === compareProductsSelection"
      [addToListSelected]="modeConfig.displayAddToListOption || productSelectionMode === addToListSelection"
      [addToInventorySelected]="modeConfig.displayAddToInventory && productSelectionMode === addToInventorySelection"
      (toggleAddToList)="handleAddToListClick()"
      (compareProducts)="handleCompareProducts()"
      (toggleAddToInventory)="handleAddToInventoryClick()"
      (selectFilterOption)="refreshSearchResult($event)"
      [isGuestUser]="isGuestUser"
    ></app-search-operations>
  </section>
</ng-template>
<ng-template #SearchOperationsMobile let-default>
  <app-search-operations
    *ngIf="!searchViewModel?.error && !isLoading"
    [orientation]="default?.orientation"
    [sortConfiguration]="default.sortConfig"
    [searchViewModel]="default?.searchViewModel"
    [showCompare]="mode !== UsfProductCardModeEnum.addToInventorySearch"
    [showAddToList]="mode !== UsfProductCardModeEnum.addToInventorySearch && modeConfig.displayAddToListButton"
    [showInventory]="mode === UsfProductCardModeEnum.addToInventorySearch && modeConfig.displayAddToInventory"
    [showDeliveryToggle]="showDeliveryToggle"
    [compareButtonSelected]="modeConfig.enableCompareButton || productSelectionMode === compareProductsSelection"
    [addToListSelected]="modeConfig.displayAddToListOption || productSelectionMode === addToListSelection"
    [addToInventorySelected]="modeConfig.displayAddToInventory && productSelectionMode === addToInventorySelection"
    (toggleAddToList)="handleAddToListClick()"
    (compareProducts)="handleCompareProducts()"
    (toggleAddToInventory)="handleAddToInventoryClick()"
    (selectFilterOption)="refreshSearchResult($event)"
    [isGuestUser]="isGuestUser"
  ></app-search-operations>
</ng-template>
<ng-template #SearchWithin let-data>
  <app-search-within
    [placeholder]="(data?.placeholder) || ('i18n.search.searchWithinSearchResults' | translate)"
    [searchViewModel]="data?.searchViewModel"
    [originSearchPage]="originSearchPage"
    [mode]="mode"
    [productSelectionMode]="productSelectionMode"
    class="search-within-search"
  >
  </app-search-within>
</ng-template>
<ng-template #OriginalItem let-data>
  <h2>Original Item</h2>
  <app-selectable-search-result
    *ngIf="!!data?.replacementBaseProduct"
    [replacementProduct]="data?.replacementBaseProduct"
    [product]="data?.replacementBaseProduct"
    [isTouchExperience]="isTouchExperience"
    [isHideQuantity]="modeConfig.originalItemHideQuantity"
    [mode]="mode"
    [selectable]="!!data?.replacementBaseProduct && productSelectionMode === compareProductsSelection"
  >
  </app-selectable-search-result>
</ng-template>
<div
  class="top-button"
  [class.has-selection]="(modeConfig.selectableItem || !!productSelectionMode) && selectedProducts?.length>0"
  *ngIf="platformService.platformType !== platformService.platformEnum.mobile && !isLoading"
>
  <ion-button
    data-cy="top-button"
    class="usf-fill-green-button"
    (click)="goToTop()"
  >
    {{ 'i18n.common.top' | translate }}
    <ion-icon
      name="chevron-up-circle-outline"
      class="top-button-icon"
      data-cy="top-button-icon"
    ></ion-icon>
  </ion-button>
</div>

<!-- Floating Tooltip for Search -->
<div class="help-icon">
  <img
    data-cy="search-page-open-help-modal-button"
    src="assets/icon/custom-help-tooltip.svg"
    (click)="openHelpModal()"
  />
</div>

<!-- Link for routing to sectionToGoBack -->
<ng-template #SectionToGoBack>
  <div
    *ngIf="sectionToGoBack"
    class="back-exceptions-container"
    data-cy="exceptions-go-back-section-text"
    (click)="goBack()"
  >
    <ion-icon name="chevron-back" data-cy="exceptions-go-back-section-icon">
    </ion-icon>
    <span
      class="back-to-exceptions"
      data-cy="exceptions-go-back-section-label-text"
    >
      {{ 'i18n.search.returnTo' | translate: {previousSection : sectionToGoBack}
      }}
    </span>
  </div>
</ng-template>

<ng-template #topSection>
  <div class="top-section-img" *ngIf="!isTouchExperience">
    <div
      class="image-background"
      [style.background-image]="topSectionBackgroundImageStyle"
      [style.background-position]="topSectionBackgroundPosition"
    >
      <ion-grid class="top-section-grid">
        <ion-row class="top-section-row">
          <ion-col class="top-section-col">
            <ion-text
              class="image-text"
              [innerHTML]="topSectionImageTitle | translate"
            >
            </ion-text>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div>
  <div class="top-section-expandable-text">
    <div class="expandable-text">
      <h4>{{topSectionTextTitle | translate}}</h4>
      <p
        [style.display]="isTopSectionTextExpanded ? 'block' : 'none'"
        [innerHTML]="topSectionTextContent | translate"
      ></p>
    </div>
    <div class="view-more-container" (click)="expandTopSectionText()">
      <div class="view-more">
        {{ isTopSectionTextExpanded ? ('i18n.common.viewLess' | translate) :
        ('i18n.common.viewMore' | translate) }}
      </div>
      <ion-icon
        name="chevron-down-outline"
        class="chevron"
        *ngIf="!isTopSectionTextExpanded"
      ></ion-icon>
      <ion-icon
        name="chevron-up-outline"
        class="chevron"
        *ngIf="isTopSectionTextExpanded"
      ></ion-icon>
    </div>
  </div>
  <div></div>
</ng-template>

<ng-template #topSectionSingleBanner>
  <div class="top-section-banners">
    <div
      *ngFor="let banner of topSectionSingleBanners; index as i"
      class="top-section-single-banner-container"
      (click)="onClickTopSectionSingleBanner(i)"
    >
      <ng-container *ngIf="banner.bannerText; else noTextBanner">
        <ion-card>
          <img
            class="top-section-single-banner-img"
            src="{{ banner.backgroundImage }}"
            [style]="banner.styles"
          />
          <p>{{ banner.bannerText }}</p>
        </ion-card>
      </ng-container>
      <ng-template #noTextBanner>
        <img
          class="top-section-single-banner-img"
          src="{{ banner.backgroundImage }}"
          [style]="banner.styles"
        />
      </ng-template>
    </div>
  </div>
</ng-template>
